/** iter436 pt 1 — conteneur de page COMMUN à tous les modules (même largeur que Documents / Tâches : toute la largeur du contenu de l'application, aucune marge ni largeur maximale propre). Garde : scripts/check-page-width.mjs. */
export default function PageContainer({ children, className = "", style, testId }) {
  return <div className={`w-full min-w-0 ${className}`} style={style} data-page-container="" data-testid={testId}>{children}</div>;
}
